
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/industry-analysis",
      function () {
        return require("private-next-pages/industry-analysis/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/industry-analysis"])
      });
    }
  